import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import criCategory from './criCategory';
import controller from './cri-function.controller';
import directive from './cri-function.directive';

export default angular.module('app.components.advisory.ecat.criFunction', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  criCategory,
])
  .directive('ecatCriFunction', directive)
  .controller('CRIFunctionController', controller)
  .name;

console.log('app.components.advisory.ecat.criFunction created');
